<template>
    <md-table-row>
        <md-table-cell class="app-name">{{ app }}</md-table-cell>
        <md-table-cell v-if="isMaintenanceMode">
            <md-icon>construction</md-icon>
            Maintenance
        </md-table-cell>
        <md-table-cell v-else>
            <md-icon>done</md-icon>
            Working
        </md-table-cell>
        <md-table-cell> {{ description }}</md-table-cell>
        <md-table-cell>
            <md-button :disabled="isMaintenanceMode" :class="!isMaintenanceMode? 'md-primary' : ''" @click="actionRunMaintenance">
                Start maintenance
            </md-button>
        </md-table-cell>

        <md-dialog-confirm
            :md-active.sync="showDialog"
            md-title="Do you want to run maintenance mode?"
            md-content="Only development team can disable maintenance mode"
            md-confirm-text="Yes"
            md-cancel-text="No"
            @md-cancel="onCancel"
            @md-confirm="runMaintenanceMode"
        />
    </md-table-row>

</template>

<script>
export default {
    name: "MaintenanceModeRow",
    props: {
        app: {
            type: String,
            required: true
        },
        isMaintenanceMode: {
            type: Boolean,
            required: true
        },
        descriptionProp: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            showDialog: false
        }
    },
    computed: {
        description() {
            if (this.descriptionProp) {
                return this.descriptionProp;
            } else
                return 'Maintenance mode prevents access to the" ' + this.app + ' only';
        }
    },
    methods: {
        onCancel() {
            this.showDialog = false;
        },
        actionRunMaintenance() {
            this.showDialog = true;
        },
        runMaintenanceMode() {
            this.$api.shutItDown({
                data: {
                    app: this.app
                }
            }).then(() =>
                this.getMaintenanceModeStatus()
            );
        },
        getMaintenanceModeStatus() {
            this.$api.isInMaintenanceMode().then(() => {
                this.isMaintenanceMode = true
            })
        }
    }
}
</script>

<style scoped lang="scss">
.md-table-cell-container .md-button {
    margin: auto;
    padding: initial;
    height: auto;
    min-width: auto;
    width: auto;
    line-height: initial;
}
</style>